module.exports = __webpack_public_path__ + "static/media/404.80d22a5a.jpeg";